import './lottery.scss'
import { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { useLocal } from '@/i18n/LocalContext'
import KowTitle from '../KowTitle/KowTitle'
import TimeStatus from '@app/components/TimeStatus/TimeStatus'
import Receive from '../Receive/Receive'
import { checkPlayer } from '@/request/utils'
import RewardPreview from './RewardPreview/rewardPreview'
import { useStore } from '@/store'
import { Box } from '@app/store/lottery'
import { clickReport } from '@app/report'
import {
  getLotteryPreHomeData,
  getLotteryHomeData,
  lotteryRefresh,
  lotteryClaim,
  lotteryPreview,
} from '@app/request'
import appExpose from '@app/expose'
const { emitter } = appExpose
import { Handler } from 'mitt'
import { $alert } from '@/utils'
import Tooltips from '@/components/Tooltips/Tooltips'
import { useMaxWidth } from '@/hooks/useMaxWidth'
let timer: NodeJS.Timeout

export default function Lottery() {
  const { $t } = useLocal()
  const { state, setState, dispatch } = useStore()
  const playerId = state.login.userInfo.playerId
  const coin = state.marketData.coin
  const lowData = state.lotteryData.low
  const mediumData = state.lotteryData.medium
  const highData = state.lotteryData.high
  const serverTime = state.serverTime
  const zoneId = state.login.userInfo.zoneId

  const { safeAreaTop } = useMaxWidth()
  const coinStyle = useMemo(() => {
    const style = { transform: `translateY(${safeAreaTop}px)` }
    return style
  }, [safeAreaTop])

  const [playPending, setPlayPending] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [modalOpenPreview, setModalOpenPreview] = useState(false)
  const [propList, setPropList] = useState<RewardViewList>([])
  const list = useMemo(
    () => [highData, mediumData, lowData],
    [lowData, mediumData, highData]
  )
  const [loading, setLoading] = useState(false)
  const [serverTime_, setServerTime_] = useState(serverTime)
  // 使用useRef来保存timer，避免重复声明
  const timerRef = useRef<NodeJS.Timeout | null>(null)
  const [countdown, setCountdown] = useState('00:00:00')

  useEffect(() => {
    updateCountdown()
  }, [serverTime, zoneId])
  // 组件卸载时清除计时器
  useEffect(
    () => () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
      }
    },
    []
  )

  // 设置倒计时 根据serverTime 和timezoneMap[zoneId]计算到0点的时间差
  const updateCountdown = () => {
    if (!serverTime) return

    // 先设置初始时间
    setServerTime_(serverTime)

    // 清除之前的计时器
    if (timerRef.current) {
      clearInterval(timerRef.current)
    }

    let getCountdown = (currentTime: number) => {
      const timezoneMap = {
        1: '-5',
        2: '-5',
        3: '+8',
        5: '+9',
      }
      // 计算目标时区当前时间
      let timezoneOffset =
        timezoneMap[zoneId as Exclude<Role['zoneId'], 0>] || '0'
      if (timezoneOffset === '0') {
        switch (window.queryObj.area) {
          case 'sea':
            timezoneOffset = '+8'
            break
          case 'ea':
            timezoneOffset = '+9'
            break
          default:
            timezoneOffset = '-5'
            break
        }
      }
      // 简化时区计算
      const targetTime = new Date(
        (currentTime + (Number(timezoneOffset) - 8) * 60 * 60) * 1000
      )

      // 获取目标时区的明天零点时间
      const nextDay = new Date(targetTime)
      nextDay.setDate(nextDay.getDate() + 1)
      nextDay.setHours(0, 0, 0, 0)

      const diff = nextDay.getTime() - targetTime.getTime() // 时间差，单位毫秒
      const hours = Math.floor(diff / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)
      if (diff >= 0) {
        setCountdown(
          `${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        )
      } else {
        // 时间到，清除计时器
        setCountdown('00:00:00')
        if (timerRef.current) {
          clearInterval(timerRef.current)
          timerRef.current = null
          emitter.emit('updateLotteryData')
          updateCountdown()
        }
      }
    }

    // 启动新的计时器
    timerRef.current = setInterval(() => {
      setServerTime_((prevTime) => {
        const newTime = Number(prevTime) + 1
        // 在状态更新后立即计算倒计时
        getCountdown(newTime)
        return newTime
      })
    }, 1000)
  }
  // 刷新功能
  const refresh = useCallback(
    async (event: React.MouseEvent, index: number) => {
      event.stopPropagation()
      if (!(await checkPlayer('lottery'))) return
      let item = list[index] as Box
      if (coin < (item.refresh || 0)) {
        // $alert($t('Err_Coin_Not_Enough'))
        $alert($t('Err_Coin_Not_Enough'), {
          resolveText: $t($t('获取')),
          rejectText: $t($t('关闭')),
          onResolve: () => {
            emitter.emit('selectActivity', 'market')
          },
        })
        return
      }
      const _refresh = async () => {
        // 给你自己加一个class rotate  1s后移除
        const refreshIcon = event.target as HTMLElement
        if (refreshIcon.classList.contains('rotate')) return
        refreshIcon.classList.add('rotate')
        clickReport('refresh')
        let res = await lotteryRefresh({
          playerId,
          gear: item.type,
        })

        // coin 减 item.refresh
        dispatch({
          type: 'setState',
          data: {
            marketData: {
              ...state.marketData,
              coin: res.coin,
            },
          },
        })

        const _setList = () => {
          switch (item.type) {
            case 'lotteryLow':
              setState({
                lotteryData: {
                  low: {
                    ...res.items,
                    type: item.type,
                  },
                },
              })
              break

            case 'lotteryMedium':
              setState({
                lotteryData: {
                  medium: {
                    ...res.items,
                    type: item.type,
                  },
                },
              })
              break

            default:
              setState({
                lotteryData: {
                  high: {
                    ...res.items,
                    type: item.type,
                  },
                },
              })
              break
          }
        }

        // 执行动画
        const bubbleContent = document.querySelector(`.bubble-content-${index}`)
        bubbleContent?.classList.remove('show')
        await new Promise((resolve) => setTimeout(resolve, 1000))
        // 停止loading动画
        refreshIcon.classList.remove('rotate')
        setTimeout(() => {
          _setList()
          bubbleContent?.classList.add('show')
        }, 50)
      }
      let key = $t('是否消耗圣诞币×%{num}刷新礼盒道具').replace(
        '%{num}',
        item.refresh?.toString() || '0'
      )
      $alert(key, {
        rejectText: $t('取消'),
        resolveText: $t('确定'),
        onResolve: () => {
          _refresh()
        },
      })
    },
    [state, list]
  )
  // 购买功能
  const [buyIndex, setBuyIndex] = useState<number | undefined>(undefined)
  const [buyKey, setBuyKey] = useState<string>('')
  const [buyItem, setBuyItem] = useState<Box | null>(null)
  const buy = useCallback(
    (index: number) => async () => {
      if (!(await checkPlayer('lottery'))) return
      if (loading) return
      // 获取对应item
      let item = list[index] as Box
      if (!item.id) {
        return
      }
      // 判断圣诞币是否足够
      if (coin < item.coin) {
        $alert($t('Err_Coin_Not_Enough'), {
          resolveText: $t($t('获取')),
          rejectText: $t($t('关闭')),
          onResolve: () => {
            emitter.emit('selectActivity', 'market')
          },
        })
        return
      }

      const check = await new Promise<boolean>((resolve) => {
        $alert($t('确认购买礼盒？'), {
          rejectText: $t('取消'),
          rejectClose: true,
          onResolve() {
            resolve(true)
          },
          onReject() {
            resolve(false)
          },
        })
      })
      if (!check) return

      setLoading(true)

      // 购买逻辑
      const _buy = async () => {
        clickReport('buy')
        let res = await lotteryClaim({
          playerId,
          gear: item.type,
        })
        // 扣除圣诞币
        let key = item.type
        type LotteryType = 'low' | 'medium' | 'high'
        // key 全部转小写 取消lottery 类型只能是low medium high
        const nk = key.toLowerCase().replace('lottery', '')
        if (nk !== 'low' && nk !== 'medium' && nk !== 'high') {
          throw new Error(`Invalid lottery type: ${key}`)
        }
        let newkey: LotteryType = nk

        setState({
          marketData: {
            coin: res.coin,
          },
        })

        // 设置弹窗内容
        setBuyIndex(index)
        setBuyKey(newkey)
        setBuyItem({
          ...res.items,
          type: item.type,
        })
        setModalOpen(true)
        setPropList([
          {
            ...item,
            ...item.prop,
          },
        ])
      }
      await _buy()
      setLoading(false)
    },
    [list, loading, coin]
  )
  // 打开奖励预览modal
  const openPreview = () => {
    clickReport('reward')
    setModalOpenPreview(true)
  }
  // 关闭modal
  const closeReceiveModal = useCallback(async () => {
    setModalOpen(false)

    if (buyIndex === undefined || !buyItem || !buyKey) return

    // 执行动画
    const refreshIcon = document.querySelector<HTMLElement>(
      `.lottery-item.item-${buyIndex}`
    )
    if (refreshIcon) {
      if (refreshIcon.classList.contains('rotate')) return
      refreshIcon.classList.add('rotate')
    }
    const bubbleContent = document.querySelector(`.bubble-content-${buyIndex}`)
    bubbleContent?.classList.remove('show')
    await new Promise((resolve) => setTimeout(resolve, 1000))
    refreshIcon?.classList.remove('rotate')
    setTimeout(() => {
      setState({
        lotteryData: {
          [buyKey]: {
            ...buyItem,
          },
        },
      })
      bubbleContent?.classList.add('show')
      setBuyIndex(undefined)
      setBuyKey('')
      setBuyItem(null)
    }, 50)
  }, [buyIndex, buyKey, buyItem])
  const closeModal = () => {
    setModalOpenPreview(false)
  }
  // 获取init数据
  useEffect(() => {
    // 获取init数据
    // pre data
    const handler_: Handler<void> = async () => {
      const data = await getLotteryPreHomeData(playerId)
      dispatch({ type: 'setState', data: { lotteryData: data } })
    }
    // init data
    const handler: Handler<void> = async () => {
      const data = await getLotteryHomeData(playerId)
      dispatch({ type: 'setState', data: { lotteryData: data } })
    }

    emitter.on('updateLotteryData', handler)
    emitter.on('getPreBaseData', handler_)
    emitter.on('getBaseData', handler)
    return () => {
      emitter.off('updateLotteryData', handler)
      emitter.off('getPreBaseData', handler_)
      emitter.off('getBaseData', handler)
    }
  }, [playerId])

  return (
    <div className="lottery">
      <KowTitle text={$t('圣诞礼盒')} />
      <TimeStatus />
      <div className="coin-block">
        <Tooltips
          title={$t('庆典币')}
          content={$t(
            '圣诞礼盒货币道具，可在圣诞礼盒活动中进行消耗刷新或购买道具'
          )}
          place="right-start"
          ckey="lotterycoin"
          className="coin"
        >
          <span>{coin}</span>
        </Tooltips>
      </div>

      <div className="title-desc">
        <div className="title-content">{$t('圣诞礼盒-活动宣传语')}</div>
      </div>
      <div className="reward-block">
        <div className="reward-view-btn" onClick={() => openPreview()}>
          <div className="reward-icon"></div>
          <div className="reward-text">
            <span>{$t('奖励预览')}</span>
          </div>
        </div>
      </div>
      <div className="lottery-info">
        {list.map((item, index) => (
          <div className={`lottery-item item-${index}`} key={index}>
            <div className="lottery-box">
              <div className="lottery-box-bubble">
                <div className={`bubble-content show bubble-content-${index}`}>
                  <div
                    className="bubble-gift"
                    style={
                      item.prop
                        ? { backgroundImage: `url(${item.prop?.icon})` }
                        : {}
                    }
                  ></div>
                  <div className="bubble-bg"></div>
                  <div className="bubble-count">{item.count}</div>
                  <Tooltips
                    title={item.prop?.name || ''}
                    content={item.prop?.desc || ''}
                    ckey={`lottery-prop-${index}`}
                    className="bubble-tooltips"
                    place={index === 1 ? 'top' : 'top-start'}
                  ></Tooltips>
                  <div
                    className="bubble-refresh"
                    onClick={(event) => refresh(event, index)}
                  ></div>
                </div>
              </div>
            </div>
            <div className="lottery-buy">
              <div className="buy-info">
                <div className="lottery-icon"></div>
                <div className="lottery-price">{item.coin}</div>
              </div>
              <div className="buy-btn" onClick={buy(index)}>
                {$t('购买')}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="refresh-time">
        <div>
          {$t('距下次礼盒自动刷新时间：')} <span>{countdown}</span>
        </div>
        <div>{$t('手动刷新礼盒道具需消耗圣诞币')}</div>
      </div>
      <Receive
        open={modalOpen}
        propList={propList}
        onClose={closeReceiveModal}
        pending={playPending}
      />
      <RewardPreview
        open={modalOpenPreview}
        onClose={closeModal}
        pending={playPending}
      />
    </div>
  )
}
